import './App.css';
import './admin/admin.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

// ========== ADMIN IMPORTS ==========
import LoginPage from './admin/pages/LoginPage';
import AdminLayout from './admin/layout/AdminLayout';
import Dashboard from './admin/pages/Dashboard';
import LeadsPage from './admin/pages/LeadsPage';
import CallLogsPage from './admin/pages/CallLogsPage';
import TasksPage from './admin/pages/TasksPage';
import TeamPage from './admin/pages/TeamPage';
import AccountingPage from './admin/pages/AccountingPage';
import ReportsPage from './admin/pages/ReportsPage';
import EmployeeDashboard from './admin/pages/EmployeeDashboard';
import { useAuth } from './hooks/useFirebase';

// ========== PUBLIC COMPONENTS ==========
import Home from './components/Home/home';
import AboutPage from './components/About/aboutPage';
import ServicePage from './components/Services/servicePage';
import ServiceDetail from './components/Services/ServiceDetail';
import Blog from './components/Blog/blog';
import ContactPage from './components/Contact/contactPage';
import Nav from './components/Nav/nav';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer/footer';
import SingleBlog from './components/Blog/single_blog';
import FloatButtons from './components/FloatButtons/FloatButtons';
import PrivacyPolicyPage from './components/PrivacyPolicy/PrivacyPolicyPage';
import Portfoliopage from './components/Portfolio/Portfoliopage';
import BulkUploadPage from './admin/pages/BulkUploadPage';

// =============================================
// ROLE-BASED PAGE RENDERER
// =============================================
function RoleBasedDashboard({ user }) {
  const [activePage, setActivePage] = useState("dashboard");

  // Admin/Manager ke liye full access
  const isAdmin = user?.role === "admin" || user?.role === "manager";

  const renderPage = () => {
    // Employee ke liye - sirf Employee Dashboard
    if (!isAdmin) {
      return <EmployeeDashboard setActivePage={setActivePage} />;
    }

    // Admin/Manager ke liye - full dashboard
    switch (activePage) {
      case "dashboard": return <Dashboard />;
      case "leads": return <LeadsPage />;
      case "calls": return <CallLogsPage />;
       case "bulk-upload":  return <BulkUploadPage />;
      case "tasks": return <TasksPage />;
      case "team": return <TeamPage />;
      case "accounting": return <AccountingPage />;
      case "reports": return <ReportsPage />;
      default: return <Dashboard />;
    }
  };

  return (
    <AdminLayout
      activePage={activePage}
      setActivePage={setActivePage}
      user={user}
    >
      {renderPage()}
    </AdminLayout>
  );
}

// =============================================
// ADMIN GUARD
// =============================================
function AdminGuard() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#f5f7fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Inter, Segoe UI, system-ui, sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 64, height: 64,
            backgroundColor: '#0066FF',
            borderRadius: 16,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px',
            boxShadow: '0 4px 20px rgba(0,102,255,0.3)'
          }}>
            <span style={{ color: 'white', fontWeight: 'bold', fontSize: 20 }}>SD</span>
          </div>
          <h2 style={{ fontSize: 18, fontWeight: 'bold', color: '#1a1a2e', margin: 0 }}>
            Loading SDtech Admin...
          </h2>
          <p style={{ fontSize: 14, color: '#999', marginTop: 4 }}>Please wait</p>
        </div>
      </div>
    );
  }

  if (!user) return <LoginPage />;

  return <RoleBasedDashboard user={user} />;
}

// =============================================
// MAIN APP
// =============================================
function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true, offset: 100 });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>

        {/* PUBLIC ROUTES */}
        <Route path="/" element={<><Nav /><Home /><Footer /><FloatButtons /></>} />
        <Route path="/about" element={<><Nav /><AboutPage /><Footer /><FloatButtons /></>} />
        <Route path="/services" element={<><Nav /><ServicePage /><Footer /><FloatButtons /></>} />
        <Route path="/services/:serviceSlug" element={<><Nav /><ServiceDetail /><Footer /><FloatButtons /></>} />
        <Route path="/blog" element={<><Nav /><Blog /><Footer /><FloatButtons /></>} />
        <Route path="/blog/:blogId" element={<><Nav /><SingleBlog /><Footer /><FloatButtons /></>} />
        <Route path="/portfoliopage" element={<><Nav /><Portfoliopage /><Footer /><FloatButtons /></>} />
        <Route path="/contact" element={<><Nav /><ContactPage /><Footer /><FloatButtons /></>} />
        <Route path="/get-quote" element={<><Nav /><ContactPage /><Footer /><FloatButtons /></>} />
        <Route path="/privacy-policy" element={<><Nav /><PrivacyPolicyPage /><Footer /><FloatButtons /></>} />

        {/* ADMIN PANEL */}
        <Route path="/admin/*" element={<AdminGuard />} />

      </Routes>
    </Router>
  );
}

export default App;